// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-project-item {
    margin-bottom: 25px;
}
textarea.side-project-details{
    min-height: 200px !important;
    height: 200px !important;
}
  
.select-month + .ant-form-item-children-icon{
    margin-right: 24px;
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/sideProject/SideProject.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;AACA;IACI,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".side-project-item {\n    margin-bottom: 25px;\n}\ntextarea.side-project-details{\n    min-height: 200px !important;\n    height: 200px !important;\n}\n  \n.select-month + .ant-form-item-children-icon{\n    margin-right: 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
